/**
 * SFL search panel offset — sets --sfl-header-offset from sticky header height.
 * Does not change sticky/logo behavior.
 */
(function () {
  function measure() {
    var group = document.querySelector('.shopify-section-group-header-group');
    if (!group) return;
    var h = Math.ceil(group.getBoundingClientRect().height);
    if (h > 40 && h < 240) {
      document.documentElement.style.setProperty('--sfl-header-offset', (h + 8) + 'px');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', measure);
  } else {
    measure();
  }
  window.addEventListener('resize', measure);
  // remeasure when search opens (header may change)
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.header__icon--search, .header__search')) {
      setTimeout(measure, 30);
    }
  }, true);
})();
